export enum RecommendTypeSearchEnum {
  WHOLE = 'WHOLE',
  CHAPTER = 'CHAPTER',
  ENDED = 'ENDED',
  NOT_END = 'NOT_END',
}
